var alignmentStyle = {"alignLeft":"J5BZN","textWrapNowrap":"RFOFN","alignRight":"_1amWU","alignCenter":"ha0L-","sizeFullWidth":"qBy-i","renderedInTable":"oqNJ1","sizeOriginal":"hxlxS","sizeContent":"XUXqx","sizeSmall":"_1CFDW","sizeSmallCenter":"_22Vvp","flex":"Y77CB","LEFT":"FH4ow","CENTER":"vweC4","RIGHT":"Qpdwb","AUTO":"_5HuoZ","JUSTIFY":"_4M3bV"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-59a07d57.js.map
